
export default class {

    constructor() {
        return {
            /*ATENÇÃO REPLICAR NO ARQUIVO pageFormFieldMixin.js*/
            fieldId: 0,
            name: "",
            type: "I",
            var: 3,
            mask: "",
            decimalPrecision: 2,
            length: 0,
            columns: 6,
            help: "",
            note: "",
            minAccepted: 0.0,
            maxAccepted: 0.0,
            createdShow: true,
            createdEnabled: true,
            updateShow: true,
            updatedEnabled: true,
            required: true,
            fixed: false,
            acceptZero: false,
            options: [],
            /*ATENÇÃO REPLICAR NO ARQUIVO pageFormFieldMixin.js*/

        }
    }


}